class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[data-predictive-search]');
      this.predictiveSearchResults = this.querySelector('.predictive-search');
      this.loadingState = this.querySelector('.predictive-search__loading-state');
      this.resultsContainer = this.querySelector('.predictive-search__results');
      
      if (!this.input || !this.predictiveSearchResults || !this.loadingState || !this.resultsContainer) return;
      
      this.setupEventListeners();
    }
  
    setupEventListeners() {
      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
      this.input.addEventListener('input', debouncedOnChange.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
    }
  
    async onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.predictiveSearchResults.hidden = false;
      this.loadingState.hidden = false;
      this.resultsContainer.hidden = true;
  
      try {
        const searchUrl = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product,collection&resources[limit]=4&resources[options][unavailable_products]=last`;
        const response = await fetch(searchUrl);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        
        this.loadingState.hidden = true;
        this.resultsContainer.hidden = false;
        this.renderSearchResults(data);
      } catch (error) {
        this.close();
        this.resultsContainer.innerHTML = '<p class="predictive-search-no-results">An error occurred while searching</p>';
        this.resultsContainer.hidden = false;
      }
    }
  
    onFocus() {
      if (this.input.value.length) {
        this.predictiveSearchResults.hidden = false;
      }
    }
  
    close() {
      this.predictiveSearchResults.hidden = true;
      this.loadingState.hidden = true;
      this.resultsContainer.hidden = true;
    }
  
    renderSearchResults(data) {
      const products = data.resources.results.products || [];
      const collections = data.resources.results.collections || [];
  
      const resultsHTML = `
        ${collections.length ? `
          <div class="predictive-search-section">
            <h3 class="text-sm mb-1">Collections</h3>
            <ul>
              ${collections.map(collection => `
                <li>
                  <a href="${collection.url}" class="predictive-search-item">
                    ${collection.title}
                  </a>
                </li>
              `).join('')}
            </ul>
          </div>
        ` : ''}
        
        ${products.length ? `
          <div class="predictive-search-section">
            <h3 class="text-sm mb-1">Products</h3>
            <ul>
              ${products.map(product => `
                <li>
                  <a href="${product.url}" class="predictive-search-item">
                    ${product.title}
                  </a>
                </li>
              `).join('')}
            </ul>
          </div>
        ` : ''}
        
        ${!products.length && !collections.length ? `
          <p class="predictive-search-no-results">No results found</p>
        ` : ''}
      `;
      this.resultsContainer.innerHTML = resultsHTML;
    }
}
  
function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
}

// Initialize search functionality
function initSearch() {
    const searchModal = document.getElementById('searchModal');
    if (!searchModal) return;

    const searchInput = searchModal.querySelector('input[type="search"]');
    const closeButton = searchModal.querySelector('.search-close');
    const snizeSearchInput = document.querySelector('.search-input.snize-input-style');
    const snizeResults = document.getElementById('snize-search-results');
    
    // Get all search buttons
    const searchButtons = document.querySelectorAll('.header__icon--search, .mobile-navigation__icon--search');
    
    customElements.define('predictive-search', PredictiveSearch);
    
    searchButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Handle mobile search button specifically
            if (button.classList.contains('mobile-navigation__icon--search')) {
                // Focus and activate snize search if available
                if (snizeSearchInput) {
                    snizeSearchInput.focus();
                    snizeSearchInput.setAttribute('aria-expanded', 'true');
                    if (snizeResults) {
                        snizeSearchInput.setAttribute('aria-controls', 'snize-search-results');
                        snizeResults.style.display = 'block';
                    }
                } else {
                    // Fallback to modal search
                    searchModal.showModal();
                    searchInput.focus();
                }
            } else {
                // Regular desktop search
                searchModal.showModal();
                searchInput.focus();
            }
            
            button.setAttribute('aria-expanded', 'true');
            
            // Close mobile nav if open
            const mobileNav = document.querySelector('.mobile-navigation');
            if (mobileNav?.classList.contains('is-active')) {
                mobileNav.classList.remove('is-active');
                document.body.style.overflow = '';
            }
        });
    });
    
    // Close handlers
    const closeSearch = () => {
        if (searchModal.open) searchModal.close();
        if (snizeSearchInput) {
            snizeSearchInput.setAttribute('aria-expanded', 'false');
            if (snizeResults) snizeResults.style.display = 'none';
        }
        searchButtons.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    };
    
    closeButton?.addEventListener('click', closeSearch);
    searchModal?.addEventListener('click', (e) => e.target === searchModal && closeSearch());
    document.addEventListener('keydown', (e) => e.key === 'Escape' && closeSearch());
    searchModal?.addEventListener('close', closeSearch);
}

document.addEventListener('DOMContentLoaded', initSearch);